import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
const Login = resolve => require(['@/components/Login'], resolve);
const SignUp = resolve => require(['@/components/SignUp'], resolve);
// const CheckPhone = resolve => require(['@/components/signUp/CheckPhone'], resolve);
const InputInfo = resolve => require(['@/components/signUp/InputInfo'], resolve);
const SignUpDone = resolve => require(['@/components/signUp/SignUpDone'], resolve);
const GoodsList = resolve => require(['@/components/GoodsList'], resolve);
const GoodsDetail = resolve => require(['@/components/GoodsDetail'], resolve);
const ShoppingCart = resolve => require(['@/components/ShoppingCart'], resolve);
const Order = resolve => require(['@/components/Order'], resolve);
const Pay = resolve => require(['@/components/Pay'], resolve);
const Help = resolve => require(['@/components/Help'], resolve);
const PayDone = resolve => require(['@/components/PayDone'], resolve);
const Freeback = resolve => require(['@/components/Freeback'], resolve);
const Home = resolve => require(['@/components/Home'], resolve);
const MyAddress = resolve => require(['@/components/home/MyAddress'], resolve);
const AddAddress = resolve => require(['@/components/home/AddAddress'], resolve);
const MyOrder = resolve => require(['@/components/home/MyOrder'], resolve);
const MyShoppingCart = resolve => require(['@/components/home/MyShoppingCart'], resolve);
const Merchant = resolve => require(['@/components/Merchant'], resolve);
const OrderDetail = resolve => require(['@/components/home/OrderDetail'], resolve);
const Privacy = resolve => require(['@/components/helper/privacy'], resolve);
const ResetKey = resolve => require(['@/components/ResetKey'], resolve);
const ResetPassword = resolve => require(['@/components/resetKey/ResetPassword'], resolve);
const ResetDone = resolve => require(['@/components/resetKey/ResetDone'], resolve);
const MyInvoice = resolve => require(['@/components/home/MyInvoice'], resolve);
const AddInvoice = resolve => require(['@/components/home/AddInvoice'], resolve);

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/Help/:id', // 帮助详情
      name: 'Help',
      component: Help
    },
    {
      path: '/Login', // 登录
      name: 'Login',
      component: Login
    },
    {
      path: '/SignUp', // 注册
      name: 'SignUp',
      component: SignUp,
      children: [
        {
          path: 'inputInfo',
          name: 'InputInfo',
          component: InputInfo
        },
        {
          path: 'signUpDone',
          name: 'SignUpDone',
          component: SignUpDone
        }
      ]
    },
    {
      path: '/ResetKey',
      name: 'ResetKey',
      component: ResetKey,
      children: [
        {
          path: 'resetPassword',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: 'resetDone',
          name: 'ResetDone',
          component: ResetDone
        }
      ]
    },
    {
      path: '/goodsList', // 商品列表
      name: 'GoodsList',
      component: GoodsList
    },
    {
      path: '/goodsDetail', // 商品详情
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/goodsDetail/:sku', // 商品详情
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/shoppingCart', // 商品详情
      name: 'ShoppingCart',
      component: ShoppingCart
    },
    {
      path: '/order', // 订单页面
      name: 'Order',
      component: Order
    },
    {
      path: '/pay', // 支付页面
      name: 'Pay',
      component: Pay
    },
    {
      path: '/payDone', // 支付成功页面
      name: 'PayDone',
      component: PayDone
    },
    {
      path: '/freeback', // 反馈页面
      name: 'Freeback',
      component: Freeback
    },
    {
      path: '/home', // 主页
      name: 'Home',
      component: Home,
      children: [
        {
          path: '/',
          name: 'HomeIndex',
          component: MyOrder
        },
        {
          path: 'myAddress',
          name: 'MyAddress',
          component: MyAddress
        },
        {
          path: 'addAddress',
          name: 'AddAddress',
          component: AddAddress
        },
        {
          path: 'myInvoice',
          name: 'MyInvoice',
          component: MyInvoice
        },
        {
          path: 'addInvoice',
          name: 'AddInvoice',
          component: AddInvoice
        },
        {
          path: 'myOrder',
          name: 'MyOrder',
          component: MyOrder
        },
        {
          path: 'myShoppingCart',
          name: 'MyShoppingCart',
          component: MyShoppingCart
        },
        {
          path: 'myOrderDetail',
          name: 'myOrderDetail',
          component: OrderDetail
        }
      ]
    },
    // {
    //   path: '/helper',
    //   name: 'Helper',
    //   component: Helper,
    //   children: [
    //     {
    //       path: 'privacy',
    //       name: 'Privacy',
    //       component: Privacy
    //     }
    //   ]
    // },
    {
      path: '/helper/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component: Merchant
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js